export default function Signup() {
  return <h3>Sign Up</h3>;
}
